export default __webpack_public_path__ + "static/media/sayyes-horizontal.2e865089.png";